import SEO from '../components/SEO';
import { webGames } from '../data/games';
import { trackEvent } from '../utils/analytics';
import './Games.css';

const Games = () => {
  return (
    <>
      <SEO
        title="Games"
        description="Play free online puzzle and arcade games at IdeaPetal Games, including Mines Garden, Snake Garden, Memory Bloom, and Petal 2048."
        keywords="online games, mini games, free games, play games, minesweeper, snake, 2048, memory games"
      />
      <div className="games-page">
        <div className="games-header">
          <div className="container">
            <h1>Free Browser Games</h1>
            <p>Pick a puzzle, chase a score, and come back for the daily challenge.</p>
          </div>
        </div>

        <div className="games-container">
          <div className="container">
            <div className="games-grid">
              {webGames.map((game) => (
                <article key={game.id} className="game-item">
                  <img className="game-thumbnail-large" src={game.image} alt={`${game.name} game preview`} />
                  <div className="game-info">
                    {game.dailyChallenge && <p className="daily-card-label">Daily challenge</p>}
                    <h2>{game.name}</h2>
                    <p className="game-category">{game.category}</p>
                    <p className="game-description">{game.description}</p>
                    <a
                      href={`/games/${game.slug}#play`}
                      className="play-game-button"
                      onClick={() =>
                        trackEvent('game_card_click', {
                          game_id: game.id,
                          game_name: game.name,
                          source: 'games_grid',
                        })
                      }
                    >
                      Play Now
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Games;
